import React from 'react';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import { BigTitle, Caption } from '@/components';

function LandingDepositConditions({ setOpen }) {
  const navigate = useNavigate();
  const handleNavigateToSteps = () => {
    navigate('/deposit-card/apply');
  };

  const location = window.location.host;

  return (
    <div tw='sm:py-20 py-14 bg-secondary sm:px-5'>
      <div tw='max-w-app mx-auto'>
        <BigTitle text={'Условия и тарифы'} twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`} />

        <table tw='min-w-full divide-y divide-grey my-10'>
          <tbody tw='divide-y divide-grey '>
            <tr>
              <td tw='p-5 bg-[#444444] rounded-t-2xl align-top '>Вид карты</td>
              <td tw='font-bold p-5'>
                Неименная Mastercard World
                <br />
                <Caption text={<span>пластиковая, цифрового аналога нет</span>} twStyle={tw`text-secondary`} />
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top '>Валюта </td>
              <td tw='font-bold p-5'>тенге, доллары, евро, рубли, юань, лира, дирхам</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Выпуск</td>
              <td tw='font-bold p-5 '>0 ₸</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Доставка</td>
              <td tw='font-bold p-5 text-justify'>
                Комиссия за выпуск и доставку пластиковой карты составляет 20 000 тенге (или эквивалент в другой валюте)
                и будет списана с вашей платежной карты. В случае отказа от доставки комиссия не возвращается.
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Обслуживание</td>
              <td tw='font-bold p-5'>бесплатно</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Срок действия</td>
              <td tw='font-bold p-5'>до 12 месяцев</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Переводы на карты других банков РК</td>
              <td tw='font-bold p-5'>1,5%</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Переводы на карты зарубежных банков</td>
              <td tw='font-bold p-5'>
                1%
                <Caption text={<span>минимум 250 тенге</span>} twStyle={tw`text-secondary`} />
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Пополнения</td>
              <td tw='font-bold p-5'>бесплатно</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Конвертации</td>
              <td tw='font-bold p-5'>бесплатно</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Снятие наличных</td>
              <td tw='font-bold p-5'>
                от 1,5%
                <Caption text={<span>минимум 250 тенге</span>} twStyle={tw`text-secondary`} />
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Максимальная сумма единоразового перевода c карты на карту</td>
              <td tw='font-bold p-5'>5 000 $ за один раз</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444]  rounded-b-2xl align-top'>Максимальная сумма всех переводов с карты на карту</td>
              <td tw='font-bold p-5'>100 000 $ в месяц</td>
            </tr>
          </tbody>
        </table>
        <div tw='flex gap-2 cursor-pointer'>
          <a
            href={`https://bankffin.kz/docs/tariffs_depositcard_ru.pdf?v=1.6`}
            target={'_blank'}
            tw='border-b divide-y'
            rel='noreferrer'
          >
            Полный список тарифов по карте
          </a>
          <span tw='bg-[#484444] rounded-xl px-2 h-[25px]'>PDF</span>
        </div>
      </div>
    </div>
  );
}

export default LandingDepositConditions;
